<template>
  <div class="wrapper">
    <HeaderView />
    <SliderView />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <BreadcrumbView />
      <router-view></router-view>
      <back-top
        class="btn-bottom"
        bottom="5%"
        right="2%"
        :slow="1"
      >
        <i class="fas fa-chevron-up"></i>
      </back-top>
    </div>
    <FooterView />
    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
  </div>
</template>

<script>
import HeaderView from './header'
import SliderView from './slider'
import FooterView from './footer'
import BreadcrumbView from './breadcrumb'

export default {
  components: {
    HeaderView,
    FooterView,
    SliderView,
    BreadcrumbView
  },
  mounted () {
    this.checkUser()
  }
}
</script>

<style>
.btn-bottom {
  background: #000;
  color: #fff;
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 0px;
  right: 15px;
  border-radius: 5px;
  opacity: 0.4;
  filter: alpha(opacity=40);
  cursor: pointer;
  font-size: 40px;
  text-align: center;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue